<template>
  <v-card flat>
    <v-card-text>
      <v-row>
        <v-col cols="12" sm="12" class="pt-0 text-right">
          <v-btn color="primary" @click="getProjectSummary">Refresh</v-btn>
        </v-col>
      </v-row>
      <v-row v-if="summary.total_units === 0">
        <v-col cols="12" sm="12" class="text-center alert alert-danger">
          <h3 class="mb-0">No Data Found, please upload PM file.</h3>
        </v-col>
      </v-row>
      <v-row v-if="summary.total_units > 0">
        <v-col cols="12" sm="3">
          <div class="bg-light-success text-center pt-3 pb-3">
            <p class="font-weight-bold font-size-h3 mb-3 text-dark">
              Construction Status
            </p>
            <p class="font-weight-bold font-size-h6 m-0 text-dark">
              {{ project.status_percentage ? project.status_percentage + '%' : 'N/A' }}
            </p>
          </div>
        </v-col>
        <v-col cols="12" sm="3">
          <div class="bg-light-success text-center pt-3 pb-3">
            <p class="font-weight-bold font-size-h3 mb-3 text-dark">
              Project Configuration
            </p>
            <p class="font-weight-bold font-size-h6 m-0 text-dark">
              {{ project.configuration ? project.configuration : 'N/A' }}
            </p>
          </div>
        </v-col>
        <v-col cols="12" sm="3">
          <div class="bg-light-success text-center pt-3 pb-3">
            <p class="font-weight-bold font-size-h3 mb-3 text-dark">
              Number of Units
            </p>
            <p class="font-weight-bold font-size-h6 m-0 text-dark">
              {{ summary.total_units ? summary.total_units : 'N/A' }}
            </p>
          </div>
        </v-col>
        <v-col cols="12" sm="3">
          <div class="bg-light-success text-center pt-3 pb-3">
            <p class="font-weight-bold font-size-h3 mb-3 text-dark">
              Number of Floors
            </p>
            <p class="font-weight-bold font-size-h6 m-0 text-dark">
              {{ summary.no_of_floor ? summary.no_of_floor : 'N/A' }}
            </p>
          </div>
        </v-col>
        <v-col cols="12" sm="3">
          <div class="bg-light-success text-center pt-3 pb-3">
            <p class="font-weight-bold font-size-h3 mb-3 text-dark">
              Property Types
            </p>
            <p class="font-weight-bold font-size-h6 m-0 text-dark">
              {{ summary.property_types ? summary.property_types : 'N/A' }}
            </p>
          </div>
        </v-col>
        <v-col cols="12" sm="3">
          <div class="bg-light-success text-center pt-3 pb-3">
            <p class="font-weight-bold font-size-h3 mb-3 text-dark">
              Bedroom Types
            </p>
            <p class="font-weight-bold font-size-h6 m-0 text-dark">
              {{ summary.bed_types ? summary.bed_types : 'N/A' }}
            </p>
          </div>
        </v-col>
        <v-col cols="12" sm="3">
          <div class="bg-light-success text-center pt-3 pb-3">
            <p class="font-weight-bold font-size-h3 mb-3 text-dark">
              Total Sales
            </p>
            <p class="font-weight-bold font-size-h6 m-0 text-dark">
              {{ summary.total_sales ? summary.total_sales : '0' }}
            </p>
          </div>
        </v-col>
        <v-col cols="12" sm="3">
          <div class="bg-light-success text-center pt-3 pb-3">
            <p class="font-weight-bold font-size-h3 mb-3 text-dark">
              Total Transactions
            </p>
            <p class="font-weight-bold font-size-h6 m-0 text-dark">
              {{ summary.total_transactions ? summary.total_transactions : '0' }}
            </p>
          </div>
        </v-col>
        <v-col cols="12" sm="3">
          <div class="bg-light-success text-center pt-3 pb-3">
            <p class="font-weight-bold font-size-h3 mb-3 text-dark">
              Total Number of Parking
            </p>
            <p class="font-weight-bold font-size-h6 m-0 text-dark">
              {{ summary.total_parking ? summary.total_parking : '0' }}
            </p>
          </div>
        </v-col>
      </v-row>
      <hr v-if="summary.total_units > 0">
      <v-row v-if="summary.total_units > 0">
        <v-col cols="12">
          <div class="mt-2 mb-5 text-center">
            <h1 class="text-dark"><b>Property Types</b></h1>
          </div>
          <div class="bg-white">
            <v-simple-table class="simple-table">
              <template v-slot:default>
                <thead>
                <tr>
                  <th>Property Type</th>
                  <th>Number Of Units</th>
                  <th>Minimum BUA (Sqft)</th>
                  <th>Maximum BUA (Sqft)</th>
                  <th v-if="summary.is_v === 1">Minimum Plot Area (Sqft)</th>
                  <th v-if="summary.is_v === 1">Maximum Plot Area (Sqft)</th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="(item, ind) in summary.property_types_data"
                    :key="ind"
                >
                  <td>{{ item.type }}</td>
                  <td>{{ item.count }}</td>
                  <td>{{ item.min_area }}</td>
                  <td>{{ item.max_area }}</td>
                  <td v-if="summary.is_v === 1">{{ item.min_plot_area }}</td>
                  <td v-if="summary.is_v === 1">{{ item.max_plot_area }}</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </v-col>
      </v-row>
      <v-row
          v-if="summary.total_units > 0 && summary.hasOwnProperty('property_types_bd') && summary.property_types_bd.length > 0">
        <v-col cols="12" v-for="(item, i) in summary.property_types_bd"
               :key="i">
          <div class="mt-2 mb-5 text-center">
            <h1 class="text-dark"><b>{{ item.unit_type }}'s Breakdown</b></h1>
          </div>
          <div class="bg-white">
            <v-simple-table class="simple-table">
              <template v-slot:default>
                <thead>
                <tr>
                  <th>Sr.</th>
                  <th>BUA (Sqft)</th>
                  <th>Number of Units</th>
                  <th v-if="item.unit_type === 'Apartment'">Bedroom Types</th>
                  <th v-if="item.unit_type !== 'Villa' && item.unit_type !== 'Townhouse' && item.unit_type !== 'Plot' && item.unit_type !== 'Land'">
                    Series
                  </th>
                  <th>Original Price</th>
                  <th>Current Price</th>
                </tr>
                </thead>

                <tbody
                    v-if="item.unit_type !== 'Villa' && item.unit_type !== 'Townhouse' && item.unit_type !== 'Plot' && item.unit_type !== 'Land'">
                <tr v-for="(area, x) in item.areas" :key="x">
                  <td>{{ x + 1 }}</td>
                  <td>{{ area.area }}</td>
                  <td>{{ area.count }}</td>
                  <td v-if="item.unit_type === 'Apartment'">{{ area.beds }}</td>
                  <td>{{ area.series }}</td>
                  <td>{{
                      area.min_price && area.min_date ? area.min_price + ' (' + formatDate(area.min_date) + ')' : 'N/A'
                    }}
                  </td>
                  <td>{{
                      area.max_price && area.max_date ? area.max_price + ' (' + formatDate(area.max_date) + ')' : 'N/A'
                    }}
                  </td>
                </tr>
                </tbody>

                <tbody v-else>
                <tr v-for="(areas, xx) in item.areas" :key="xx">
                  <td>{{ xx + 1 }}</td>
                  <td>{{ areas.area }}</td>
                  <td>{{ areas.count }}</td>
                  <td>{{
                      areas.min_price && areas.min_date ? areas.min_price + ' (' + formatDate(areas.min_date) + ')' : 'N/A'
                    }}
                  </td>
                  <td>{{
                      areas.max_price && areas.max_date ? areas.max_price + ' (' + formatDate(areas.max_date) + ')' : 'N/A'
                    }}
                  </td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
          <div class="mt-5 mb-5 text-center">
            <h1 class="text-dark"><b>{{ item.unit_type }}'s Transactions History</b></h1>
          </div>
          <div class="bg-white">
            <v-tabs v-model="i" background-color="#002366" left dark>
              <v-tab>1 Year</v-tab>
              <v-tab>2 Years</v-tab>
              <v-tab>3 Years</v-tab>
              <v-tab>4 Years</v-tab>
              <v-tab>5 Years</v-tab>

              <v-tab-item>
                <v-card>
                  <v-simple-table class="simple-table">
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th>Sr.</th>
                        <th>BUA (Sqft)</th>
                        <th>Minimum Price</th>
                        <th>Maximum Price</th>
                      </tr>
                      </thead>

                      <tbody>
                      <tr v-for="(y1, x) in item.year_1" :key="x">
                        <td>{{ x + 1 }}</td>
                        <td>{{ y1.area }}</td>
                        <td>{{ y1.min_price ? y1.min_price : 'N/A' }}</td>
                        <td>{{ y1.max_price ? y1.max_price : 'N/A' }}</td>
                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card>
                  <v-simple-table class="simple-table">
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th>Sr.</th>
                        <th>BUA (Sqft)</th>
                        <th>Minimum Price</th>
                        <th>Maximum Price</th>
                      </tr>
                      </thead>

                      <tbody>
                      <tr v-for="(y2, x) in item.year_2" :key="x">
                        <td>{{ x + 1 }}</td>
                        <td>{{ y2.area }}</td>
                        <td>{{ y2.min_price ? y2.min_price : 'N/A' }}</td>
                        <td>{{ y2.max_price ? y2.max_price : 'N/A' }}</td>
                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card>
                  <v-simple-table class="simple-table">
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th>Sr.</th>
                        <th>BUA (Sqft)</th>
                        <th>Minimum Price</th>
                        <th>Maximum Price</th>
                      </tr>
                      </thead>

                      <tbody>
                      <tr v-for="(y3, x) in item.year_3" :key="x">
                        <td>{{ x + 1 }}</td>
                        <td>{{ y3.area }}</td>
                        <td>{{ y3.min_price ? y3.min_price : 'N/A' }}</td>
                        <td>{{ y3.max_price ? y3.max_price : 'N/A' }}</td>
                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card>
                  <v-simple-table class="simple-table">
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th>Sr.</th>
                        <th>BUA (Sqft)</th>
                        <th>Minimum Price</th>
                        <th>Maximum Price</th>
                      </tr>
                      </thead>

                      <tbody>
                      <tr v-for="(y4, x) in item.year_4" :key="x">
                        <td>{{ x + 1 }}</td>
                        <td>{{ y4.area }}</td>
                        <td>{{ y4.min_price ? y4.min_price : 'N/A' }}</td>
                        <td>{{ y4.max_price ? y4.max_price : 'N/A' }}</td>
                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card>
                  <v-simple-table class="simple-table">
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th>Sr.</th>
                        <th>BUA (Sqft)</th>
                        <th>Minimum Price</th>
                        <th>Maximum Price</th>
                      </tr>
                      </thead>

                      <tbody>
                      <tr v-for="(y5, x) in item.year_5" :key="x">
                        <td>{{ x + 1 }}</td>
                        <td>{{ y5.area }}</td>
                        <td>{{ y5.min_price ? y5.min_price : 'N/A' }}</td>
                        <td>{{ y5.max_price ? y5.max_price : 'N/A' }}</td>
                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </div>
        </v-col>
      </v-row>
      <hr v-if="summary.total_units > 0">
      <v-row v-if="summary.total_units > 0">
        <v-col cols="12">
          <div class="mt-2 mb-5 text-center">
            <h1 class="text-dark"><b>Bedrooms</b></h1>
          </div>
          <div class="bg-white">
            <v-simple-table class="simple-table">
              <template v-slot:default>
                <thead>
                <tr>
                  <th>Bedroom Type</th>
                  <th>Number Of Units</th>
                  <th>Minimum BUA (Sqft)</th>
                  <th>Maximum BUA (Sqft)</th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="(item, i) in summary.bed_types_data"
                    :key="i"
                >
                  <td>{{ item.type }}</td>
                  <td>{{ item.count }}</td>
                  <td>{{ item.min_area }}</td>
                  <td>{{ item.max_area }}</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </v-col>
      </v-row>
      <v-row v-if="summary.total_units > 0 && summary.hasOwnProperty('beds_bd') && summary.beds_bd.length > 0">
        <v-col cols="12" v-for="(item, i) in summary.beds_bd"
               :key="i">
          <div class="mt-2 mb-5 text-center">
            <h1 class="text-dark"><b>{{ item.beds }}{{ item.beds !== 'Studio' ? ' Bedroom' : '' }}'s Breakdown</b></h1>
          </div>
          <div class="bg-white">
            <v-simple-table class="simple-table">
              <template v-slot:default>
                <thead>
                <tr>
                  <th>Sr.</th>
                  <th>BUA (Sqft)</th>
                  <th>Number of Units</th>
                  <th v-if="item.is_v !== 1">Series</th>
                  <th>Original Price</th>
                  <th>Current Price</th>
                </tr>
                </thead>

                <tbody v-if="item.is_v !== 1">
                <tr v-for="(area, x) in item.areas" :key="x">
                  <td>{{ x + 1 }}</td>
                  <td>{{ area.area }}</td>
                  <td>{{ area.count }}</td>
                  <td>{{ area.series }}</td>
                  <td>{{
                      area.min_price && area.min_date ? area.min_price + ' (' + formatDate(area.min_date) + ')' : 'N/A'
                    }}
                  </td>
                  <td>{{
                      area.max_price && area.max_date ? area.max_price + ' (' + formatDate(area.max_date) + ')' : 'N/A'
                    }}
                  </td>
                </tr>
                </tbody>

                <tbody v-else>
                <tr v-for="(areas, xx) in item.areas" :key="xx">
                  <td>{{ xx + 1 }}</td>
                  <td>{{ areas.area }}</td>
                  <td>{{ areas.count }}</td>
                  <td>{{
                      areas.min_price && areas.min_date ? areas.min_price + ' (' + formatDate(areas.min_date) + ')' : 'N/A'
                    }}
                  </td>
                  <td>{{
                      areas.max_price && areas.max_date ? areas.max_price + ' (' + formatDate(areas.max_date) + ')' : 'N/A'
                    }}
                  </td>

                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>

          <div class="mt-5 mb-5 text-center">
            <h1 class="text-dark"><b>{{ item.beds }}{{ item.beds !== 'Studio' ? ' Bedroom' : '' }}'s Transactions History</b></h1>
          </div>
          <div class="bg-white">
            <v-tabs v-model="i" background-color="#002366" left dark>
              <v-tab>1 Year</v-tab>
              <v-tab>2 Years</v-tab>
              <v-tab>3 Years</v-tab>
              <v-tab>4 Years</v-tab>
              <v-tab>5 Years</v-tab>

              <v-tab-item>
                <v-card>
                  <v-simple-table class="simple-table">
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th>Sr.</th>
                        <th>BUA (Sqft)</th>
                        <th>Minimum Price</th>
                        <th>Maximum Price</th>
                      </tr>
                      </thead>

                      <tbody>
                      <tr v-for="(y1, x) in item.year_1" :key="x">
                        <td>{{ x + 1 }}</td>
                        <td>{{ y1.area }}</td>
                        <td>{{ y1.min_price ? y1.min_price : 'N/A' }}</td>
                        <td>{{ y1.max_price ? y1.max_price : 'N/A' }}</td>
                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card>
                  <v-simple-table class="simple-table">
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th>Sr.</th>
                        <th>BUA (Sqft)</th>
                        <th>Minimum Price</th>
                        <th>Maximum Price</th>
                      </tr>
                      </thead>

                      <tbody>
                      <tr v-for="(y2, x) in item.year_2" :key="x">
                        <td>{{ x + 1 }}</td>
                        <td>{{ y2.area }}</td>
                        <td>{{ y2.min_price ? y2.min_price : 'N/A' }}</td>
                        <td>{{ y2.max_price ? y2.max_price : 'N/A' }}</td>
                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card>
                  <v-simple-table class="simple-table">
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th>Sr.</th>
                        <th>BUA (Sqft)</th>
                        <th>Minimum Price</th>
                        <th>Maximum Price</th>
                      </tr>
                      </thead>

                      <tbody>
                      <tr v-for="(y3, x) in item.year_3" :key="x">
                        <td>{{ x + 1 }}</td>
                        <td>{{ y3.area }}</td>
                        <td>{{ y3.min_price ? y3.min_price : 'N/A' }}</td>
                        <td>{{ y3.max_price ? y3.max_price : 'N/A' }}</td>
                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card>
                  <v-simple-table class="simple-table">
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th>Sr.</th>
                        <th>BUA (Sqft)</th>
                        <th>Minimum Price</th>
                        <th>Maximum Price</th>
                      </tr>
                      </thead>

                      <tbody>
                      <tr v-for="(y4, x) in item.year_4" :key="x">
                        <td>{{ x + 1 }}</td>
                        <td>{{ y4.area }}</td>
                        <td>{{ y4.min_price ? y4.min_price : 'N/A' }}</td>
                        <td>{{ y4.max_price ? y4.max_price : 'N/A' }}</td>
                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card>
                  <v-simple-table class="simple-table">
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th>Sr.</th>
                        <th>BUA (Sqft)</th>
                        <th>Minimum Price</th>
                        <th>Maximum Price</th>
                      </tr>
                      </thead>

                      <tbody>
                      <tr v-for="(y5, x) in item.year_5" :key="x">
                        <td>{{ x + 1 }}</td>
                        <td>{{ y5.area }}</td>
                        <td>{{ y5.min_price ? y5.min_price : 'N/A' }}</td>
                        <td>{{ y5.max_price ? y5.max_price : 'N/A' }}</td>
                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import {mapState} from "vuex";
import {GET_PROJECTS_SUMMARY} from "@/core/services/store/projects.module";

export default {
  name: 'project-summary',
  props: ['project'],
  data() {
    return {
      summary: {}
    }
  },
  watch: {
    project() {
      this.getProjectSummary()
    }
  },
  mounted() {
    this.getProjectSummary()
  },
  methods: {
    getProjectSummary() {
      this.$store.dispatch(GET_PROJECTS_SUMMARY, this.project.id).then((data) => {
        this.summary = data.records
      });
    }
  },
  computed: {
    ...mapState({
      errors: state => state.projects.errors
    })
  }
};
</script>